import { Link, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { getRedirectToFromSearch, buildLoginUrl } from "@/lib/redirect";

const Unauthorized = () => {
  const [searchParams] = useSearchParams();
  const next = getRedirectToFromSearch(searchParams.toString());
  const loginTo = next ? buildLoginUrl(next) : "/login";

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <p className="mb-2 text-2xl font-bold tracking-tight text-primary">Farmly</p>
          <CardTitle className="text-xl">Du behöver vara inloggad</CardTitle>
          <CardDescription>Logga in för att fortsätta.</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Button asChild>
            <Link to={loginTo}>Logga in</Link>
          </Button>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="text-sm text-muted-foreground underline hover:text-foreground"
          >
            Gå tillbaka
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default Unauthorized;
